// extracted by mini-css-extract-plugin
module.exports = {"dashed":"LineTrace_dashed__1J8Z7"};